@if (exercise | async; as exercise) {
  @if (!waiting) {
    <section class="col-8 mx-auto text-center">
      <header>
        <h1>Exercise Goals</h1>
      </header>
      <div class="jumbotron">
        <div class="row">
          <div [ngClass]="exercise.pacingGoal > 0 ? 'col-6' : 'col-12'">
            <h3 class="display-3">{{exercise.accuracyGoal + '%'}}</h3>
            <h4>
              Accuracy<br>
              <i class="fa fa-bullseye"></i>
            </h4>
          </div>
          @if (exercise.pacingGoal > 0) {
            <div class="col-6">
              <h3 class="display-3">{{exercise.pacingGoal + 's'}}</h3>
              <h4>
                Per Question<br>
                <i class="fa fa-stopwatch"></i>
              </h4>
            </div>
          }
        </div>
      </div>
      <p class="lead">{{exercise.introCopy}}</p>
      <a class="btn btn-primary btn-lg" (click)="handleGetStarted()">Get Started</a>
    </section>
  } @else {
    <app-spinner></app-spinner>
  }
} @else {
  <app-spinner></app-spinner>
}
